import { render, staticRenderFns } from "./newProductReviewList.vue?vue&type=template&id=b75a36c2&scoped=true"
import script from "./newProductReviewList.vue?vue&type=script&lang=js"
export * from "./newProductReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75a36c2",
  null
  
)

export default component.exports